/**
 * Post-auth landing: unfinished intake (no kryspace workspace yet) must resume
 * prospector, not Control Bridge (which requires a workspace slug).
 */

import { CONTROL_BRIDGE_HOME_PATH } from './controlBridgeRoutes';
import { normalizeNextPath, POST_REGISTER_PATH } from './onboardingNavigation';

export type CompanySlugRow = {
  company: { kryspace_slug?: string | null };
};

/** True when the user has no company with a usable kryspace workspace slug. */
export function userNeedsProspectorIntake(companies: CompanySlugRow[]): boolean {
  return !companies.some((row) => Boolean(row.company.kryspace_slug?.trim()));
}

/**
 * Choose where to send the user after password/MFA succeeds.
 * Explicit `/onboarding/*` next targets always win; otherwise incomplete intake
 * overrides the Control Bridge default.
 */
export function resolvePostLoginPath(
  requestedNext: string | null | undefined,
  companies: CompanySlugRow[],
  options?: { registered?: boolean }
): string {
  const fallback = options?.registered ? POST_REGISTER_PATH : CONTROL_BRIDGE_HOME_PATH;
  const normalized = normalizeNextPath(requestedNext ?? null, fallback);

  if (normalized.startsWith('/onboarding/')) {
    return normalized;
  }

  if (userNeedsProspectorIntake(companies)) {
    return POST_REGISTER_PATH;
  }

  return normalized;
}
